// extracted by mini-css-extract-plugin
export var featureCard = "featureCard-module--featureCard--ddcaa";
export var headline = "featureCard-module--headline--79556";
export var image = "featureCard-module--image--9f97e";
export var imageContainer = "featureCard-module--imageContainer--f1d66";
export var text = "featureCard-module--text--f7591";
export var textContainer = "featureCard-module--textContainer--65b56";